/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    top: 0,
    width: '100%',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default
  },
  componentHeader: {
    paddingLeft: theme.spacing(6),
    backgroundColor: theme.palette.background.default
  },
  isIframe: {
    marginLeft: theme.spacing(1.5)
  },
  componentHeaderWrap: {
    backgroundColor: theme.palette.background.default,
    height: "48px",
    borderWidth: "0px 0px thin",
    borderStyle: "solid",
    borderColor: "#b8b8b840",
  },
  darkThemeWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  menuItemText: {
    marginLeft: theme.spacing(1),
  }
}));

